// extracted by mini-css-extract-plugin
export default {"title":"assessmentcard_title__Aihaf","card":"assessmentcard_card__N9chc","mainCon":"assessmentcard_mainCon__XhTVX"};